import { createReducer, on } from '@ngrx/store';
import { initialContratoState } from './contrato.state';
import * as ContratoActions from './contrato.actions';

export const contratoReducer = createReducer(
  initialContratoState,

  // Load Contratos
  on(ContratoActions.loadContratos, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(ContratoActions.loadContratosSuccess, (state, { contratos }) => ({
    ...state,
    contratos,
    loading: false,
    error: null
  })),

  on(ContratoActions.loadContratosFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Create Contrato
  on(ContratoActions.createContrato, state => ({
    ...state,
    creating: true,
    error: null
  })),

  on(ContratoActions.createContratoSuccess, (state, { contrato }) => ({
    ...state,
    contratos: [...state.contratos, contrato],
    creating: false,
    error: null
  })),

  on(ContratoActions.createContratoFailure, (state, { error }) => ({
    ...state,
    creating: false,
    error
  })),

  // Update Contrato
  on(ContratoActions.updateContrato, state => ({
    ...state,
    updating: true,
    error: null
  })),

  on(ContratoActions.updateContratoSuccess, (state, { contrato }) => ({
    ...state,
    contratos: state.contratos.map(c =>
      c.numeroContratoId === contrato.numeroContratoId ? contrato : c
    ),
    updating: false,
    error: null
  })),

  on(ContratoActions.updateContratoFailure, (state, { error }) => ({
    ...state,
    updating: false,
    error
  })),

  // Delete Contrato
  on(ContratoActions.deleteContrato, state => ({
    ...state,
    deleting: true,
    error: null
  })),

  on(ContratoActions.deleteContratoSuccess, (state, { id }) => ({
    ...state,
    contratos: state.contratos.filter(c => c.numeroContratoId !== id),
    deleting: false,
    error: null
  })),

  on(ContratoActions.deleteContratoFailure, (state, { error }) => ({
    ...state,
    deleting: false,
    error
  })),

  // Search Contratos
  on(ContratoActions.searchContratos, (state, { query }) => ({
    ...state,
    searchQuery: query
  })),

  on(ContratoActions.searchContratosSuccess, (state, { results }) => ({
    ...state,
    searchResults: results
  })),

  on(ContratoActions.clearContratoSearch, state => ({
    ...state,
    searchResults: [],
    searchQuery: ''
  })),

  // Select Contrato
  on(ContratoActions.selectContrato, (state, { contrato }) => ({
    ...state,
    selectedContrato: contrato
  })),

  // Clear Error
  on(ContratoActions.clearContratoError, state => ({
    ...state,
    error: null
  }))
);
